import { render, staticRenderFns } from "./pages-header.vue?vue&type=template&id=4bcc68f2&scoped=true&"
import script from "./pages-header.vue?vue&type=script&lang=js&"
export * from "./pages-header.vue?vue&type=script&lang=js&"
import style0 from "./pages-header.vue?vue&type=style&index=0&id=4bcc68f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc68f2",
  null
  
)

export default component.exports